export interface GetStartedBenefit {
	icon: string
	label: string
}

export interface GetStartedPageContent {
	seoTitle: string
	seoDescription: string
	valueProposition: string
	/** Carousel heading — use `{month}` as a placeholder for the current month name */
	carouselHeading: string
	/** Title of the "& more" end card shown when the collection has more products than the carousel displays */
	carouselMoreTitle: string
	/** Subtext of the "& more" end card */
	carouselMoreSubtext: string
	benefits: GetStartedBenefit[]
	planSelectionHeading: string
	planSelectionFallbackSubheadline: string
	billingMonthly: string
	/** Template string — use `{months}`, `{currency}`, `{total}` as placeholders */
	billingMultimonthTemplate: string
	planLabelMonthly: string
	planLabelAnnual: string
	ctaContinueToCheckout: string
	authHeading: string
	authSubtext: string
	stepLabelQuiz: string
	stepLabelPlan: string
	stepLabelCheckout: string
	surveyContinueLabel: string
}

export const FALLBACK_PAGE_CONTENT: GetStartedPageContent = {
	seoTitle: 'Get Started | Birchbox',
	seoDescription: 'Take our beauty quiz and find your perfect subscription box.',
	valueProposition: 'Up to $110 value every month',
	carouselHeading: 'Inside Our {month} Box',
	carouselMoreTitle: '& more',
	carouselMoreSubtext: 'to choose from',
	benefits: [
		{ icon: 'fa-light fa-sparkles', label: 'Personalized\nfor you' },
		{ icon: 'fa-light fa-sliders', label: 'Customize\nbefore it ships' },
		{ icon: 'fa-light fa-rotate-left', label: 'Cancel\nanytime' }
	],
	planSelectionHeading: 'Choose your plan',
	planSelectionFallbackSubheadline: 'Discover why so many people love Birchbox ❤️',
	billingMonthly: 'Billed Monthly, Ships Every Month',
	billingMultimonthTemplate: 'Billed Every {months} Months for {currency}{total}, Ships Every Month',
	planLabelMonthly: 'Monthly',
	planLabelAnnual: 'Annual',
	ctaContinueToCheckout: 'Continue to checkout',
	authHeading: 'Create your account',
	authSubtext: 'This saves your beauty profile and lets you manage your Birchbox subscription.',
	stepLabelQuiz: 'Beauty Quiz',
	stepLabelPlan: 'Choose Plan',
	stepLabelCheckout: 'Checkout',
	surveyContinueLabel: 'Continue'
}
